export const HOWTV_COMPANY_ADDRESS =
  '〒106-6128 東京都港区六本木6-10-1 六本木ヒルズ森タワー28F';
